import React from 'react';

const LogoPlaceholder = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path d="M8 11.7143L11 16.2952L15.5 8L22 21H2L8 11.7143Z" fill="#768093" />
        <circle cx="9" cy="6" r="3" fill="#768093" />
    </svg>
);

export default LogoPlaceholder;